
export enum SystemWorkOrderStatus {
    Open = 'Open',
    InProgress = 'In Progress',
    OnHold = 'On Hold',
    Completed = 'Completed',
    Finalised = 'Finalised',
    Closed = 'Closed',
    Canceled = 'Canceled'
}

//Status values that are still considered 'Open'
export const OpenSystemWorkOrderStatusValues = [SystemWorkOrderStatus.Open, SystemWorkOrderStatus.InProgress, SystemWorkOrderStatus.OnHold];

/**
 * The public API's code for each system status (`in_progress`), as its stage and Job payloads report it; the enum value is the
 * label WorkBuddy shows. Read by the public transformer.
 */
export const PublicSystemWorkOrderStatus: Record<SystemWorkOrderStatus, string> = {
    [SystemWorkOrderStatus.Open]: 'open',
    [SystemWorkOrderStatus.InProgress]: 'in_progress',
    [SystemWorkOrderStatus.OnHold]: 'on_hold',
    [SystemWorkOrderStatus.Completed]: 'completed',
    [SystemWorkOrderStatus.Finalised]: 'finalised',
    [SystemWorkOrderStatus.Closed]: 'closed',
    [SystemWorkOrderStatus.Canceled]: 'cancelled',
};
